var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sy-container__main syue-clr sy-bottom-fixed-parent"},[_c('div',{class:{'sy-container__main_content': true, 'no-top': _vm.$route.meta['menuCode'] && !_vm.$route.meta.noTopPadding}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }